import * as moment from 'moment';

import { BaseEntity, MemoizeGetters, Transform, toDate } from './base';

@MemoizeGetters
export class MessageModel extends BaseEntity {
  body?: string;
  yoshi?: boolean;
  mediaUrl?: string;

  @Transform(toDate)
  createdAt?: Date;

  get relativeTime() {
    let momentDate = moment(this.createdAt);
    return momentDate.fromNow();
  }
}



// WEBPACK FOOTER //
// ./src/models/message.ts